export default "__VITE_ASSET__D3gU6TfW__"